import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';

import Stack from '@mui/material/Stack';

export const StyledLogo = styled(Box)({
  maxHeight: '100px',
  maxWidth: '100px'
});

export const StyledProfileImage = styled(Avatar)({
  height: '50px',
  width: '50px'
});

export const StyledStackContainer = styled(Stack)(({ theme }) => ({
  position: 'absolute',
  flexDirection: 'row',
  justifyContent: 'space-between',
  padding: '15px',
  width: '100vw',
  height: '160px',
  zIndex: '-1',
  [theme.breakpoints.down('lg')]: {
    padding: '20px 20px 100px',
    height: 'fit-content'
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '25px'
  }
}));

export const StyledStackProfileTitle = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '15px',
  height: 'min-content'
});

export const StyledStackLogo = styled(Box)(({ theme }) => ({
  width: '100px',
  height: '100px',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));

export const StyledStackTitle = styled(Stack)({
  alignItems: 'end',
  gap: '5px',
  fontSize: '14px',
  h6: {
    lineHeight: 1,
    fontSize: '1em'
  },
  p: {
    lineHeight: 1,
    fontSize: '.8em'
  }
});



// WEBPACK FOOTER //
// ./src/containers/CampaignLandingPage/styles.js